import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-20cc47dc")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "filters_panel" }
const _hoisted_3 = { key: 1 }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, {
      showDelete: false,
      showSave: false,
      title: 'Ordini App'
    }),
    _createVNode(_component_Panel, {
      collapsed: false,
      class: "p-mb-3",
      header: "Filtri avanzati",
      toggleable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Calendar, {
            modelValue: _ctx.advFilters.from_to,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.advFilters.from_to = $event)),
            manualInput: false,
            showIcon: true,
            selectionMode: "range",
            placeholder: "Data creazione",
            onDateSelect: _ctx.updateFilters
          }, null, 8, ["modelValue", "onDateSelect"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_AppTable, {
      ref: "dataTable",
      filtersSchema: _ctx.filters,
      service: _ctx.service,
      stateKey: _ctx.stateKey,
      sortField: "created_at",
      sortOrder: -1,
      onResetFilters: _ctx.onReset,
      onRowClick: _ctx.onRowClick
    }, {
      columns: _withCtx(({onApplyFilter}) => [
        _createVNode(_component_Column, {
          field: "created_at",
          header: "Data",
          sortable: true
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_DateFormatted, {
              date: data.created_at
            }, null, 8, ["date"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "pickup_city",
          header: "Città Ritiro",
          sortable: true,
          showFilterMatchModes: false
        }, {
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              placeholder: "Città...",
              onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-check",
              label: "Applica",
              class: "p-button-success",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          field: "pickup_address",
          header: "Indirizzo Ritiro",
          sortable: true,
          showFilterMatchModes: false
        }, {
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              placeholder: "Indirizzo...",
              onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-check",
              label: "Applica",
              class: "p-button-success",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          field: "delivery_city",
          header: "Città Consegna",
          sortable: true,
          showFilterMatchModes: false
        }, {
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              placeholder: "Città...",
              onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-check",
              label: "Applica",
              class: "p-button-success",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          field: "delivery_address",
          header: "Indirizzo Consegna",
          sortable: true,
          showFilterMatchModes: false
        }, {
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              placeholder: "Indirizzo...",
              onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-check",
              label: "Applica",
              class: "p-button-success",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          field: "package_size",
          header: "Dimensione",
          sortable: true,
          showFilterMatchModes: false
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_Tag, {
              value: _ctx.getPackageSizeLabel(data.package_size),
              severity: "info"
            }, null, 8, ["value"])
          ]),
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_component_Dropdown, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.packageSizeOptions,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "Tutti",
              showClear: true,
              onChange: ($event: any) => (onApplyFilter(filterCallback)),
              onClear: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange", "onClear"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          field: "price_offered",
          header: "Prezzo Offerto",
          sortable: true,
          showFilterMatchModes: false,
          bodyStyle: "text-align: right",
          headerStyle: "text-align: right"
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(_ctx.formatAmount(data.price_offered)), 1)
          ]),
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              placeholder: "Prezzo...",
              onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-check",
              label: "Applica",
              class: "p-button-success",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          field: "offers_count",
          header: "N. Offerte",
          sortable: true,
          bodyStyle: "text-align: center",
          headerStyle: "text-align: center"
        }, {
          body: _withCtx(({data}) => [
            (data.offers_count > 0)
              ? (_openBlock(), _createBlock(_component_Badge, {
                  key: 0,
                  value: data.offers_count
                }, null, 8, ["value"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, "0"))
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "status",
          header: "Stato",
          sortable: true,
          showFilterMatchModes: false
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_Tag, {
              value: _ctx.getStatusLabel(data.status),
              severity: _ctx.getStatusSeverity(data.status)
            }, null, 8, ["value", "severity"])
          ]),
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_component_Dropdown, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.statusOptions,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "Tutti",
              showClear: true,
              onChange: ($event: any) => (onApplyFilter(filterCallback)),
              onClear: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange", "onClear"])
          ]),
          _: 2
        }, 1024)
      ]),
      actions: _withCtx(({data}) => [
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-eye",
          class: "p-button-info p-button-sm",
          onClick: ($event: any) => (_ctx.goToDetail(data.id))
        }, null, 8, ["onClick"]), [
          [
            _directive_tooltip,
            'Visualizza dettaglio',
            void 0,
            { bottom: true }
          ]
        ])
      ]),
      _: 1
    }, 8, ["filtersSchema", "service", "stateKey", "onResetFilters", "onRowClick"])
  ]))
}